<div class="d-flex justify-content-between align-items-center">
  <h4 class="mb-0">
    {{ domainForm.get('domain_description')?.value }} <casi-help-button *ngIf="domainForm.get('help_info_id')?.value" [infoId]="domainForm.get('help_info_id')?.value" style="display: inline-block;"></casi-help-button></h4>
  <div class="d-flex align-items-center" *ngIf="domainForm.get('can_opt_out')?.value" style="font-size: 18px">
    <label class="k-checkbox-label mb-0"><b>Opt Out</b></label>
    <input type="checkbox" kendoCheckBox [formControl]="optOut" (change)="onOptOutChange($event.target.checked)" style="margin-left: 6px"/>
  </div>
</div>

<p>{{domainForm.get('domain_instruction')?.value}}</p>

<div>
  <div style="width: 30%"></div>
  <div style="width: 70%"></div>
</div>
<table  formArrayName="rating_scale" class="rating-scale-table">
  <tbody>
  <tr class="top-row">
    <td  rowspan="3" style="width:30%">Scale for Reference</td>
    <td *ngFor="let d of scaleArray.controls; let i = index" [formGroupName]="i" [class.first-scale-cell]="i === 0">{{d.get('rating_scale_name')?.value}}</td>
  </tr>

  <tr>
    <td *ngFor="let d of scaleArray.controls; let i = index" [formGroupName]="i" >{{d.get('rating_scale_value')?.value}}</td>
  </tr>

  </tbody>
</table>

<table *ngIf="!domainForm.get('opt_out')?.value">
  <tbody>
    <tr *ngFor="let q of domain_answers.controls; let i = index">
      <td style="width: 30%">{{ q.get('question')?.value }}</td>
      <td style="width: 70%">
        <div class="k-form-field d-flex flex-column w-100">
          <div class="d-flex align-items-center gap-2 w-100">
            <kendo-slider class="flex-grow-1 w-90"
              [formControl]="getAnswerControl(q, 'value')" [min]="getMinScaleValue()" [max]="getMaxScaleValue()" [smallStep]="0.1">
            </kendo-slider>
          </div>

          <div class="text-center fw-bold mt-1 w-100" >
            {{ getAnswerControl(q, 'value')?.value }}
          </div>

          <div *ngIf="getAnswerControl(q, 'value')?.invalid" class="alert alert-danger custom-alert">
            <div *ngIf="getAnswerControl(q, 'value')?.errors?.['required']">It's required</div>
            <div *ngIf="getAnswerControl(q, 'value')?.errors?.['min']
            && !getAnswerControl(q, 'value')?.errors?.['pattern']">Minimum allowed value is {{ getMinScaleValue() }}</div>
            <div *ngIf="getAnswerControl(q, 'value')?.errors?.['max']
            && !getAnswerControl(q, 'value')?.errors?.['pattern']">Maximum allowed value is {{ getMaxScaleValue() }}</div>
          </div>
        </div>
      </td>
    </tr>

    <tr>
      <td style="width: 70%">{{ domainForm.get('domain_description')?.value }}, Average Score</td>
      <td style="width: 30%">
        <input type="number" class="form-control"  style="text-align: center" [value]="averageScore" readonly>
      </td>
    </tr>
  <tr>
    <td colspan="2">
      <div class="k-form-field d-flex flex-column">
        <label class="k-label mb-1">Optional Comment:</label>
        <textarea class="form-control" [formControl]="comment" rows="3"></textarea>
      </div>
    </td>
  </tr>
  </tbody>
</table>

